/**
 * Selectbox Linkhandling.
 *
 * All 'Verteilerseiten'-pages have Selectforms with links.
 * Selecting an option redirecting to this link
 */

jQuery(document).ready(function($) {
    $( '.js-select-link' ).on('change', function() {
        selected_link = $( '.js-select-link' ).val();
        window.location.replace(selected_link);
    });
});
